import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "task-details"
}
const _hoisted_6 = { class: "container row m-0 p-lg-1 ps-md-2" }
const _hoisted_7 = { class: "form-group col-12 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", {
  for: "task-name",
  class: "me-2"
}, "Client:", -1 /* HOISTED */)
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "mt-2 mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Current/Last Episode Period:", -1 /* HOISTED */)
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Agency:", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12" }, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "form-group col-12 col-md-8 col-lg-3 mt-lg-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "employee" }, " Visit Type: ", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_18 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_19 = { class: "form-group col-12 col-md-8 col-lg-3 mt-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "employee" }, " User/Employee: ", -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_22 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_23 = {
  key: 0,
  class: "form-group col-6 col-md-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, null, -1 /* HOISTED */)
const _hoisted_25 = { class: "mt-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_27 = { class: "form-group form-check custom-checkbox col-10 mt-2 ms-3" }
const _hoisted_28 = ["checked"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "billable"
}, " Post to AxxessCARE ", -1 /* HOISTED */)
const _hoisted_30 = {
  key: 1,
  class: "form-group col-12 col-md-3 mt-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, " Task Type: ", -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Task Type", -1 /* HOISTED */)
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_35 = { class: "form-group col-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("hr", { class: "ms-0" }, null, -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Visit Orders", -1 /* HOISTED */)
const _hoisted_38 = {
  key: 0,
  class: "w-50"
}
const _hoisted_39 = { class: "table table-responsive-md border border-gray" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Discipline"),
  /*#__PURE__*/_createElementVNode("th", null, "Frequency"),
  /*#__PURE__*/_createElementVNode("th", null, "Effective Date")
], -1 /* HOISTED */)
const _hoisted_41 = { class: "white-space-pre" }
const _hoisted_42 = { class: "white-space-pre" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "form-group col-12" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("hr", { class: "ms-0" }, null, -1 /* HOISTED */)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, " To schedule visits for the selected user, click on the desired dates in the calendar below: ", -1 /* HOISTED */)
const _hoisted_47 = { class: "form-group col-12 ps-md-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("input", { class: "form-control" }, null, -1 /* HOISTED */)
const _hoisted_49 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex col-12 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group col-md-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-md-nowrap" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend scheduled" }),
        /*#__PURE__*/_createTextVNode(" Scheduled ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend completed" }),
        /*#__PURE__*/_createTextVNode(" Completed ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend missed" }),
        /*#__PURE__*/_createTextVNode(" Missed ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend multiple" }),
        /*#__PURE__*/_createTextVNode(" Multiple ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend disabled" }),
        /*#__PURE__*/_createTextVNode(" Disabled ")
      ])
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_51 = {
  key: 2,
  class: "d-flex flex-wrap-reverse flex-md-nowrap justify-content-center my-2"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_MultiDatePickerHH = _resolveComponent("MultiDatePickerHH")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_FormSection, {
      "full-height": false,
      title: "Employee Scheduler",
      "application-id": _ctx.visitDetails.Application,
      "show-product-pill": true,
      "show-background": false
    }, {
      content: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
          : (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.visitDetails.FirstName) + " " + _toDisplayString(_ctx.visitDetails.LastName), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(_ctx.carePeriod), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("span", null, _toDisplayString(_ctx.visitDetails.AgencyName), 1 /* TEXT */)
                  ])
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.availableTasksFilter,
                    value: _ctx.selectedTask,
                    onValueChanged: _ctx.changeTaskList,
                    placeholder: "Type to Select Visit Type",
                    "show-all-by-default": true,
                    "open-on-focus": true,
                    "must-select-value": true,
                    onBlurredInput: _ctx.v$.selectedTask?.$touch,
                    class: _normalizeClass(`${!_ctx.v$.selectedTask?.$error ? '' : 'field-invalid'}`)
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"]),
                  (_ctx.v$.selectedTask?.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Visit Type is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.employeeListFilter,
                    value: _ctx.scheduleEmployee,
                    onValueChanged: _ctx.changescheduleEmployee,
                    placeholder: "Type to Select User",
                    "show-all-by-default": true,
                    "open-on-focus": true,
                    onBlurredInput: _ctx.v$.newVisitDetails?.userId?.$touch,
                    class: _normalizeClass(`${!_ctx.v$.newVisitDetails?.userId?.$error ? '' : 'field-invalid'}`),
                    disabled: _ctx.employeeIsPreSelected
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class", "disabled"]),
                  (_ctx.v$.newVisitDetails?.userId?.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "User/Employee is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                (!_ctx.employeeIsPreSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.assignToMe())),
                          class: "text-decoration-none"
                        }, "Assign to me")
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "billable",
                      class: "form-check-input",
                      checked: _ctx.newVisitDetails.postToAxxessCare,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newVisitDetails.postToAxxessCare) = $event))
                    }, null, 8 /* PROPS */, _hoisted_28), [
                      [_vModelCheckbox, _ctx.newVisitDetails.postToAxxessCare]
                    ]),
                    _hoisted_29
                  ])
                ]),
                (_ctx.newVisitDetails.postToAxxessCare)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _hoisted_31,
                      _withDirectives(_createElementVNode("select", {
                        id: "task-name",
                        class: _normalizeClass(`form-select ${
                                    !_ctx.v$.newVisitDetails.discipline.$error && _ctx.newVisitDetails.postToAxxessCare
                                        ? ''
                                        : 'field-invalid mt-0'
                                }`),
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTaskTypeChange(_ctx.newVisitDetails))),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newVisitDetails.discipline) = $event))
                      }, [
                        _hoisted_32,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialties, (task, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: task.id,
                            key: index
                          }, _toDisplayString(task.name), 9 /* TEXT, PROPS */, _hoisted_33))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 34 /* CLASS, HYDRATE_EVENTS */), [
                        [_vModelSelect, _ctx.newVisitDetails.discipline]
                      ]),
                      (_ctx.v$.newVisitDetails.discipline?.$error && _ctx.newVisitDetails.postToAxxessCare)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Task Type is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _hoisted_37,
                  (_ctx.visitOrders.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("table", _hoisted_39, [
                          _createElementVNode("tbody", null, [
                            _hoisted_40,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitOrders, (order, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(order.discipline), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_41, _toDisplayString(order.frequency), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_42, _toDisplayString(order.effectiveDate), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_43, "There are no current orders for visits."))
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    (_ctx.currentEpisodeDetails)
                      ? (_openBlock(), _createBlock(_component_MultiDatePickerHH, {
                          key: 0,
                          result: _ctx.visitDates,
                          "current-episode-details": _ctx.currentEpisodeDetails,
                          visitDetails: _ctx.visitDetails,
                          onUpdateResult: _ctx.updateResult,
                          visitDates: _ctx.visitDatesList
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["result", "current-episode-details", "visitDetails", "onUpdateResult", "visitDates"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.v$.visitDates?.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, " Visit Dates is Required. "))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _hoisted_50
                ])
              ])
            ])),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              (_ctx.isSaving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _hoisted_54))
                : (_openBlock(), _createElementBlock("span", _hoisted_55, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndExit)))
                    }, " Save and Exit "),
                    _createVNode(_component_SaveNotifyUser, {
                      "agency-id": _ctx.visitDetails.AgencyId,
                      "button-name": "Save and Notify Employee",
                      onHandleSaveVisit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndNotifyEmployee)))
                    }, null, 8 /* PROPS */, ["agency-id"]),
                    _createElementVNode("button", {
                      class: "ms-2 btn btn-primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndAddAnother)))
                    }, " Save and Add Another "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ms-2 btn btn-md btn-outline-secondary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel()))
                    }, " Cancel ")
                  ]))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application-id"])
  ]))
}